<p-confirmDialog />

<aside class="sidebar" [class.sidebar--collapsed]="state.sidebarCollapsed()">
  <div class="sidebar__header">
    @if (!state.sidebarCollapsed()) {
      <span class="sidebar__title">Ask Navi</span>
    }
    <button
      type="button"
      class="sidebar__toggle"
      (click)="onToggleCollapse()"
      [attr.aria-label]="state.sidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
    >
      <i class="pi" [ngClass]="state.sidebarCollapsed() ? 'pi-angle-right' : 'pi-angle-left'"></i>
    </button>
  </div>

  @if (!state.sidebarCollapsed()) {
    <button
      type="button"
      class="sidebar__new-chat"
      [disabled]="state.isSubmitting()"
      (click)="onNewChat()"
    >
      <i class="pi pi-plus"></i>
      <span>New chat</span>
    </button>

    <div class="sidebar__list" role="list">
      @if (state.isLoadingConversations()) {
        <p class="sidebar__status">Loading…</p>
      } @else if (state.conversations().length === 0) {
        <p class="sidebar__status">No conversations yet</p>
      } @else {
        @for (conv of state.conversations(); track conv.id) {
          <div
            class="sidebar__item"
            [class.sidebar__item--active]="state.activeConversationId() === conv.id"
            role="listitem"
          >
            <button
              type="button"
              class="sidebar__item-select"
              [disabled]="state.isSubmitting()"
              (click)="onSelectConversation(conv.id)"
            >
              <span class="sidebar__item-title">{{ conv.title || 'New Conversation' }}</span>
              <span class="sidebar__item-date">{{
                formatActivity(conv.last_activity ?? conv.updated_at ?? conv.created_at)
              }}</span>
            </button>
            <p-button
              icon="pi pi-trash"
              [text]="true"
              [rounded]="true"
              severity="danger"
              styleClass="sidebar__item-delete"
              [disabled]="state.isInputDisabled()"
              [attr.aria-label]="'Delete ' + (conv.title || 'New Conversation')"
              pTooltip="Delete conversation"
              tooltipPosition="left"
              (onClick)="confirmDeleteConversation($event, conv)"
            />
          </div>
        }
      }
    </div>
  }
</aside>
